import {Component, OnInit, Input, OnChanges} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {PortalService} from '../../../vna_portal/model/PortalService';
import {AlertaService} from '../../../../../shared/services/alerta.service';
import {PortalServiceFactoryService} from '../../../services/portal-service-factory.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-service-access',
  //templateUrl: './service-access.component.html',
  styleUrls: ['./service-access.component.scss']
})
export abstract class ServiceAccessComponent implements OnInit {

  @Input() portalService: PortalService;
  @Input() type: string = 'portal';

  formSearch:FormGroup;
  enabled: boolean;

  constructor(protected portalServiceFactory: PortalServiceFactoryService, protected alertaHandler:AlertaService) {

      this.formSearch = new FormGroup(
          {
              'url' : new FormControl('',Validators.required),
          })

  }

  ngOnInit() {
      this.formSearch.controls['url'].setValue(this.portalService.getUrl());
  }

  saveConfig(form){
      if(form.valid){
          this.enabled=true;

          let criteria = { 'portal_pk' : this.portalService.pkPortal, 'service_pk' : this.portalService.pkService };
          if(_.indexOf(['camp', 'action'], this.type) >= 0){
              criteria['camp_pk'] = this.portalService.pkCamp;
              if(this.type == 'action'){
                  criteria['action_pk'] = this.portalService['pkAction'];
              }
          }

          this
              .portalServiceFactory
              .getHandler(this.type)
              .savePortalService(criteria,'service_access_parameters', this.portalService.alias, form.value)
              .subscribe( result =>{
                  this.enabled=false;
                  this.alertaHandler.addAlert('success','Service Access Parameters have been saved successfully')
              })
      }
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/service-access/service-access.component.ts